// extracted by mini-css-extract-plugin
module.exports = {"WaffleIcon":"SelectMode__WaffleIcon__1-K_5","active":"SelectMode__active__2R0a4"};